import _ from 'underscore';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import getConfig from 'next/config';
import cx from 'classnames';

import AccessibilityPromoCard from 'components/cards/AccessibilityPromoCard';
import BaseSlider from 'components/sliders/BaseSlider';
import Container from 'components/Container';
import OffsetSlider from 'components/sliders/OffsetSlider';
import RegionsCard from 'components/cards/RegionsCard';
import SpecialRubricCard from 'components/cards/SpecialRubricCard';
import SizeDependedBlock from 'components/SizeDependedBlock';

import { SCREEN_BREAKPOINTS } from 'utils/helpers/constants';

import { rubricPageCardsHash } from './dataCategories';

import styles from './styles.module.scss';

const {
	publicRuntimeConfig: { features }
} = getConfig();

const SectionCategories = ({
	federalSubjects,
	rubricName,
	showAccessibilityCard = true,
	className
}) => {
	const sliderParams = useMemo(
		() => ({
			slidesPerView: 1.05,
			spaceBetween: 8,
			breakpoints: {
				[SCREEN_BREAKPOINTS.mobileMedium]: {
					slidesPerView: 'auto',
					spaceBetween: 8
				},
				[SCREEN_BREAKPOINTS.mobileLarge]: {
					slidesPerView: 'auto',
					spaceBetween: 12
				},
				[SCREEN_BREAKPOINTS.tabletMedium]: {
					slidesPerView: 2,
					spaceBetween: 16
				},
				[SCREEN_BREAKPOINTS.tabletLarge]: {
					slidesPerView: 3,
					spaceBetween: 24
				}
			}
		}),
		[]
	);

	const allBlocksFromCategory = rubricPageCardsHash[rubricName];

	return (
		<div className={cx(styles.SectionCategories, className)}>
			<SizeDependedBlock breakpoint="tabletMedium">
				<OffsetSlider
					theme="full"
					params={sliderParams}
					lazy={features.lazy}
					containerClassName={styles.SectionCategoriesCard__Slider}
				>
					{showAccessibilityCard && (
						<div className={styles.SectionCategories__Card}>
							<AccessibilityPromoCard />
						</div>
					)}

					{allBlocksFromCategory &&
						allBlocksFromCategory.map(
							({ type, description, defaultImage, title, url }, index) => (
								<div key={type} className={styles.SectionCategories__Card}>
									<SpecialRubricCard
										{...{
											description,
											defaultImage,
											title,
											url
										}}
										colorIndex={index}
									/>
								</div>
							)
						)}

					{!_(federalSubjects).isEmpty() && (
						<div className={styles.SectionCategories__Card}>
							<RegionsCard federalSubjects={federalSubjects} />
						</div>
					)}
				</OffsetSlider>
				<Container>
					<BaseSlider params={sliderParams} lazy={features.lazy}>
						{showAccessibilityCard && (
							<div className={styles.SectionCategories__Card}>
								<AccessibilityPromoCard />
							</div>
						)}

						{allBlocksFromCategory &&
							allBlocksFromCategory.map(
								({ type, description, defaultImage, title, url }, index) => (
									<div key={type} className={styles.SectionCategories__Card}>
										<SpecialRubricCard
											{...{
												description,
												defaultImage,
												title,
												url
											}}
											colorIndex={index}
										/>
									</div>
								)
							)}

						{!_(federalSubjects).isEmpty() && (
							<div className={styles.SectionCategories__Card}>
								<RegionsCard federalSubjects={federalSubjects} />
							</div>
						)}
					</BaseSlider>
				</Container>
			</SizeDependedBlock>
		</div>
	);
};

SectionCategories.propTypes = {
	federalSubjects: PropTypes.array,
	rubricName: PropTypes.string,
	showAccessibilityCard: PropTypes.bool,
	className: PropTypes.string
};

export default SectionCategories;
